// This code is to be implemented in the third party website and is standalone. Therefore, no function imports.

const COOKIENAME = 'occ';

const getCookie = (cname) => {
    let name = cname + '=';
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i].trim();
        if (c.indexOf(name) === 0) {
            return c.substring(name.length);
        }
    }
    return '';
};

const setCookie = (cname, cvalue, exdays) => {
    window.dataLayer.push({ occ: cvalue, event: 'onconsent' });
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = 'expires=' + d.toUTCString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

const deleteCookie = (cname) => {
    if (getCookie(cname) !== '') {
        document.cookie = cname + '=' + ';expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/';
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const iframe = document.getElementById('questionnaire-iframe');
    if (!iframe) return;

    const sendConsent = () => {
        const cookie = getCookie(COOKIENAME);
        iframe.contentWindow.postMessage({ type: 'questionnaire:consent', cookie }, '*');
    };

    window.addEventListener('message', (event) => {
        if (event.data?.type === 'questionnaire:ready') {
            sendConsent();
        }

        if (event.data?.type === 'questionnaire:results') {
            if (event.data.height) {
                iframe.style.height = event.data.height + 'px';
            }
        }

        if (event.data?.type === 'questionnaire:consent') {
            if (event.data.cookie == null) {
                deleteCookie(COOKIENAME);
            } else {
                setCookie(COOKIENAME, event.data.cookie, 365);
            }
        }
    });
});
